/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Launch_Vote_ScoreInputs */

const en_directory_launch_vote_score = /** @type {(inputs: Directory_Launch_Vote_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vote ${i?.count}`)
};

const zh_directory_launch_vote_score = /** @type {(inputs: Directory_Launch_Vote_ScoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`投票 ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Vote {count}" |
*
* @param {Directory_Launch_Vote_ScoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_vote_score = /** @type {((inputs: Directory_Launch_Vote_ScoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Vote_ScoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_vote_score(inputs)
	return zh_directory_launch_vote_score(inputs)
});
export { directory_launch_vote_score as "directory.launch.vote_score" }